<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
    import Input from './Input.svelte';
    import VerticalInput from './VerticalInput.svelte';
    import { supportsVerticalFormElement } from './writingModeSupport.js';

    /**
     * In most browsers, there's native implementation for vertical `writing-mode` of Input.
     * (with exception of Safari < 17.4)
     * Component is needed to render custom vertical element in older browsers.
     * Replace with normal `Input` once no longer need to support older browsers.
     */

    export let writingMode;

    export let value;
    export let name;
    export let type;
    export let size;
    export let placeholder;
    export let disabled;
    export let readonly;
    export let ariaDescribedBy;
    export let required;
    export let pattern;
    export let maxlength;
    export let minlength;
    export let patternMessage;
    export let height;
    export let fullwidth;
    export let inputmode;
    export let hasIcon;
    export let feedback;
    export let feedbackProps;
    export let feedbackLang;
    export let customValidity;
    export let visited;

    const renderCustomVertical = writingMode === 'vertical-rl' && !supportsVerticalFormElement();
    const component = renderCustomVertical ? VerticalInput : Input;
</script>

<svelte:component
    this={component}
    {writingMode}
    {value}
    {name}
    {type}
    {size}
    {placeholder}
    {disabled}
    {readonly}
    {ariaDescribedBy}
    {required}
    {pattern}
    {maxlength}
    {minlength}
    {patternMessage}
    {height}
    {fullwidth}
    {inputmode}
    {hasIcon}
    {feedback}
    {feedbackProps}
    {feedbackLang}
    {customValidity}
    {visited}
    on:focus
    on:blur
    on:change
    on:validation
    on:clipboard
    on:dragdrop />
